import { formatBrl } from '@estac1/shared';
import { Card, CardContent } from '@estac1/ui';
import { MetricCard } from './metric-card.js';
import type { MetricsResponse } from './types.js';
import { formatPercent } from './utils.js';

interface SubscriptionsSectionProps {
  m: MetricsResponse;
}

export const SubscriptionsSection = ({ m }: SubscriptionsSectionProps) => (
  <section className="space-y-3">
    <h2 className="text-sm font-semibold">Assinaturas</h2>
    <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
      <MetricCard
        label="MRR"
        value={formatBrl(m.mrr.cents)}
        hint={`${m.mrr.payingLots} assinatura(s) ativa(s)`}
        tone="success"
      />
      <MetricCard
        label="Conversão teste → pago"
        value={formatPercent(m.conversion.trialToPaidPercent)}
        hint={
          m.conversion.trialsStarted > 0
            ? `${m.conversion.trialsConverted} de ${m.conversion.trialsStarted} testes pagaram`
            : 'sem coorte ainda'
        }
      />
      <MetricCard label="Em teste" value={m.lots.byStatus.trial.toString()} />
      <MetricCard
        label="Atrasados"
        value={m.lots.byStatus.past_due.toString()}
        tone={m.lots.byStatus.past_due > 0 ? 'danger' : undefined}
      />
      <MetricCard label="Cancelados" value={m.lots.byStatus.canceled.toString()} />
      <MetricCard label="Estac. ativos (total)" value={m.lots.total.toString()} />
      <MetricCard
        label="Teste acabando (7 dias)"
        value={m.lots.trialEndingSoon.toString()}
        tone={m.lots.trialEndingSoon > 0 ? 'danger' : undefined}
      />
      <MetricCard
        label="Add-on de avarias"
        value={m.lots.addonDamagePhotos.toString()}
        hint={`${m.lots.addonDamagePhotosBilled} cobrado(s)`}
      />
      <MetricCard
        label="Cancela"
        value={m.lots.addonBarrier.toString()}
        hint={`${m.lots.addonBarrierBilled} cobrado(s)`}
      />
      <MetricCard
        label="Impressora"
        value={m.lots.addonPrinter.toString()}
        hint={`${m.lots.addonPrinterBilled} cobrado(s)`}
      />
      <MetricCard
        label="MRR de módulos"
        value={formatBrl(m.mrr.addonCents)}
        hint={`${m.mrr.addonPercent}% do MRR (meta ≥ 15%)`}
        tone={m.mrr.addonPercent >= 15 ? 'success' : undefined}
      />
    </div>
    {(m.mrr.activeWithoutSnapshot > 0 || m.mrr.driftingLots > 0) && (
      <Card>
        <CardContent className="space-y-2 pt-6 text-sm text-muted-fg">
          {m.mrr.activeWithoutSnapshot > 0 && (
            <p>
              <strong>{m.mrr.activeWithoutSnapshot}</strong> assinatura(s) ativa(s) sem preço
              registrado ficam de fora do MRR acima. Refaça o checkout desses lotes para gravar o
              valor.
            </p>
          )}
          {m.mrr.driftingLots > 0 && (
            <p>
              <strong>{m.mrr.driftingLots}</strong> lote(s) com preço divergente da tabela atual — o
              MRR pode estar desatualizado. Rode o recálculo em Preços para reconciliar.
            </p>
          )}
        </CardContent>
      </Card>
    )}
  </section>
);
